import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=0977c202&scoped=true&"
import script from "./UpdatePassword.vue?vue&type=script&lang=js&"
export * from "./UpdatePassword.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=0977c202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0977c202",
  null
  
)

export default component.exports